import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { h5 } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.blockquote) `
  position: relative;
  padding-top: 24px;
  padding-bottom: 48px;

  @media ${from(Device.Tablet)} {
    padding-top: 64px;
    padding-bottom: 90px;
  }

  &[data-color='grey'] {
    --quoteColor: ${brand.grey.grey0};
  }

  &[data-color='blue'] {
    --quoteColor: ${brand.blue.base};
  }

  &[data-color='yellow'] {
    --quoteColor: ${brand.yellow.base};
  }
`;
const Content = styled.p `
  ${h5}
  margin: 0;
`;
const QuoteIcon = styled.span `
  position: absolute;
  color: var(--quoteColor);
  height: 42px;
  width: 48px;
  z-index: -1;

  @media ${from(Device.Tablet)} {
    height: 90px;
    width: 104px;
  }
`;
const QuoteOpen = styled(QuoteIcon) `
  top: -35px;
  left: 0;
`;
const QuoteClose = styled(QuoteIcon) `
  bottom: 0;
  right: 0;
`;
const BlockQuoteBlockStyles = {
    Container,
    Content,
    QuoteClose,
    QuoteOpen,
};
export default BlockQuoteBlockStyles;
